module.exports = __webpack_public_path__ + "static/media/responsive.c5a68f78.png";